import { Injectable } from '@angular/core';
import {environment} from "src/environments/environment";
import {Product, ProductBrand, ProductSuggesstion} from "src/app/interfaces/product";
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  api = `${environment.api}/customer/products`;
  constructor(private http: HttpClient) { }

  search(page: number =1, size: number = 20, sort : string = 'date_desc',query: string = '',category: string = 'all',filters: any = {}){
    const payload = { page: page,
                      size: size,
                      sort: sort,
                      query: query,
                      category: category,
                      ...filters}
    return this.http.post<{count: number , items: Product[]}>(`${this.api}/search`, payload ,{observe: "body"});
  }
  find(uuid: string){
    return this.http.get<Product>(`${this.api}/${uuid}`,{ observe: "body" });
  }
  brands(category: string){
    const params = new HttpParams().append('category',category);
    return this.http.get<ProductBrand[]>(`${this.api}/brands`,{ observe: "body" , params:  params } );
  }
  stats_category(){
    return this.http.get<{ all: number ; academe: number; industrial: number }>(`${this.api}/stats/category`,{ observe: "body" });
  }
  suggest(query: string, category: string = 'all', limit: number = 10) {
    const params = new HttpParams()
      .set('query', query)
      .set('category', category)
      .set('limit', limit);
    return this.http.get<{ suggestions: ProductSuggesstion[] }>(`${this.api}/suggest`, { observe: 'body', params: params });
  }
}
